<template>
  <div>
    <catalog-multi-select
      ref="catalog_select"
      catalog-name="гражданство"
      :is-disabled="isDisabled"
      :initial-value="value"
      :get-list="getItems"
      :can-create-catalog="canEditCitizenships()"
      :drop-up="dropUp"
      @onSelect="$emit('input', $event)"
      @open-modal="isModalVisible = true"
    />

    <citizenship
      v-if="isModalVisible"
      :exact-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, { PERM } from "../../../utilites/permissions";
    import CatalogMultiSelect from "../CatalogMultiSelect.vue";
    import Citizenship from "./Citizenship.vue";

export default {
  name: "EmploymentCategoriesMultiSelect",
  components: { Citizenship, CatalogMultiSelect },
  mixins: [
    catalogs,
    permissions
  ],
  props: {
    isDisabled: { type: Boolean, default: false },
    value: { type: Array, default: () => [] },
    dropUp: { type: Boolean, default: false }
  },
  data() {
    return {
      isModalVisible: false
    };
  },
  methods: {
    async getItems() {
      const result = await this.getCitizenshipsSearch("");
      return (result && result.data) ? result.data : [];
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.$emit('catalog-created', newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canEditCitizenships() {
      return this.hasPermission([PERM.CATALOG_CITIZENSHIPS_EDIT]);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Citizenships/CitizenshipsMultiSelect.vue